import React from "react";
import { Notification, toast } from "../../ui";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";

const OpenNotificationPopup = (type, message) => {
  // console.log("type, message : ", type, message);
  toast.push(
    <Notification
      type={type}
      duration={type === "success" ? 2000 : 3000}
      title={message}
      customIcon={
        type === "success" ? (
          <AiFillCheckCircle className="text-2xl" color="green" />
        ) : (
          <AiFillCloseCircle className="text-2xl" color="red" />
        )
      }
    />,
    {
      placement: "top-end",
    }
  );
};
export default OpenNotificationPopup;